import React, { FunctionComponent, useEffect, useMemo, useState } from 'react'

import { stringToHsl } from '../../../../../../../../App/Util/stringToHsl'
import { IMenuCategory } from '../../../../../../interface/IMenuCategory'
import { IFinalSelection } from '../../../../interfaces/IActivitySelect'
import { Tile } from '../Tile/Tile'

import { IProps } from './IProps'
import { getNextCategories } from './utils/getNextCategories'

export const MenuSelect: FunctionComponent<IProps> = ({
    menuList,
    setActivitySelectObject,
    activitySelectObject,
}) => {
    const { activeSelection } = activitySelectObject

    const nextCategorySelection = useMemo(() => {
        return getNextCategories(activeSelection, menuList)
    }, [activeSelection, menuList])

    const addSelectionId = (
        menuId: number,
        menuActivities: number | IFinalSelection[]
    ) => {
        if (typeof menuActivities === 'number') {
            setActivitySelectObject({
                type: 'menu',
                activeSelection: [...activeSelection, menuId],
                selectionDetails: null,
            })
            return
        }
        setActivitySelectObject({
            type: 'selected',
            activeSelection,
            selectionDetails: menuActivities,
            menuId,
        })
        return
    }

    return (
        <>
            {nextCategorySelection.map((item) => {
                const clickedTileInfo: number | IFinalSelection[] =
                    typeof item.activities !== 'undefined'
                        ? item.activities.map((activity) => ({
                              uuid: activity.uuid,
                              selectionDetails: { name: activity.name },
                          }))
                        : item.id
                return (
                    <Tile
                        key={item.id}
                        tileColor={stringToHsl(item.name, 50, 50)}
                        tileTitle={item.name}
                        onClick={() => addSelectionId(item.id, clickedTileInfo)}
                    />
                )
            })}
        </>
    )
}
